import { useLocation } from 'react-router';
import AppLoading from 'components/app/AppLoading';
import ResultsSkeleton from 'views/results/ResultsPage/ResultsSkeleton';

const RESULTS_PATHS = ['/single-results', '/multi-results'];

const RouteLoader = () => (RESULTS_PATHS.includes(useLocation().pathname) ? <ResultsSkeleton /> : <AppLoading />);

export default RouteLoader;
